import { render } from "./OpenActivityDrawer.vue?vue&type=template&id=46aaf35e&scoped=true"
import script from "./OpenActivityDrawer.vue?vue&type=script&lang=js"
export * from "./OpenActivityDrawer.vue?vue&type=script&lang=js"

import "./OpenActivityDrawer.vue?vue&type=style&index=0&id=46aaf35e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46aaf35e"]])

export default __exports__